import script from "./trending.vue?vue&type=script&setup=true&lang=js"
export * from "./trending.vue?vue&type=script&setup=true&lang=js"

import "./trending.vue?vue&type=style&index=0&id=3c05c303&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c05c303"]])

export default __exports__